module.exports = __webpack_public_path__ + "img/currency.260a7057.svg";